/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Events_Pagination_PreviousInputs */

const es_billing_events_pagination_previous = /** @type {(inputs: Billing_Events_Pagination_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anterior`)
};

const en_billing_events_pagination_previous = /** @type {(inputs: Billing_Events_Pagination_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous`)
};

/**
* | output |
* | --- |
* | "Previous" |
*
* @param {Billing_Events_Pagination_PreviousInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const billing_events_pagination_previous = /** @type {((inputs?: Billing_Events_Pagination_PreviousInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Events_Pagination_PreviousInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_billing_events_pagination_previous(inputs)
	return en_billing_events_pagination_previous(inputs)
});
export { billing_events_pagination_previous as "billing.events.pagination.previous" }